import { FC } from 'react'
import { ISubsidyBase } from '@/types'
import { SubsidyCard } from '@components-v2/molecules/SubsidyCard'
import styles from './index.module.scss'

type Props = {
  items: ISubsidyBase[]
}

export const SubsidyCardList: FC<Props> = ({ items }) => {
  if (items.length === 0) {
    return <p>お探しの補助金は見つかりませんでした。</p>
  }
  return (
    <div className={styles.container}>
      {items?.map((subsidy) => (
        <SubsidyCard key={subsidy.id} subsidy={subsidy} />
      ))}
    </div>
  )
}
